module.exports = __webpack_public_path__ + "static/img/surveillanceVideo.0724657.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/surveillanceVideo.png
// module id = D2oA
// module chunks = 1